module.exports = __webpack_public_path__ + "static/media/tab-puffs-chocolatey.a02c4d66.png";